"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Shake = _interopRequireDefault(require("./Shake"));

var _shakes = _interopRequireDefault(require("./shakes"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Shaking = function Shaking(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? null : _ref$type,
      props = _objectWithoutProperties(_ref, ["type"]);

  var attrs = type && _shakes["default"][type];
  return _react["default"].createElement(_Shake["default"], _extends({}, attrs, props), props.children);
};

var _default = Shaking;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/reshake/dist/Shaking.js
// module id = 268
// module chunks = 0